module.exports = __webpack_public_path__ + "img/Reims.cde5b670.png";